var exports = {
  "_": "x93eb46d8--cfe957--thumbnails",
};

module.exports = exports;
